const defaultState = {
  feedback: null,
}

export default defaultState
